module.exports = __webpack_public_path__ + "assets1775130923925/img/home-img.ff28be9e.jpg";